<template>
    <b-card class="unit-payload">
        <ul class="payload-items">
            <li v-for="(row, key) in payload" class="payload-item" :key="key">
                <div class="payload-item__key">
                    <action-group class="mr-2">
                        <action-button :icon="$icons.edit" @action="editKey(key)"></action-button>
                        <action-button :icon="$icons.delete" @action="deleteKey(key)"></action-button>
                    </action-group>
                    <b-input disabled :value="key"></b-input>
                </div>
                <div>
                    <x-select v-model="row.type"
                              :clearable="false"
                              :multiple="false"
                              :options="types"
                              :searchable="false"
                              @input="changeType(key,$event)"
                              valueFormat="id"
                              id-key="id"
                              label-key="name"></x-select>
                </div>
                <div>
                    <action-group v-if="row.type==='container'">
                        <container-input
                            :holder-type="'unit'"
                            :holder-id="holderId"
                            :holder-parent-type="holderParentType"
                            :holder-parent-id="holderParentId"
                            :holder-key="key"
                            :value="row.value">
                        </container-input>
                    </action-group>
                    <UnitPayloadPicture
                        v-else-if="row.type==='picture'"
                        v-model="row.value"/>
                    <UnitPayloadDate v-else-if="row.type==='date'" type="date" v-model="row.value"></UnitPayloadDate>
                    <UnitPayloadDate v-else-if="row.type==='datetime'" type="datetime"
                                     v-model="row.value"></UnitPayloadDate>
                    <b-textarea v-else-if="row.type==='textarea'" v-model="row.value" rows="6"></b-textarea>
                    <x-input v-else v-model="row.value" :show-editor="true"></x-input>
                </div>
            </li>
        </ul>
        <action-group>
            <action-button title="Add" :icon="$icons.add" @action="add">
            </action-button>
        </action-group>
    </b-card>
</template>

<script>
import pictureEmptyValue from '@/shared/pictureEmptyValue'
import UnitPayloadPicture from './UnitPayloadPicture'
import XDateTime from "@/components/XDateTime";
import UnitPayloadDate from "@/components/inputs/field/UnitPayloadDate";

export default {
    name: 'UnitPayload',
    components: {XDateTime, UnitPayloadPicture, UnitPayloadDate},
    model: {
        prop: 'payload',
        event: 'change'
    },
    props: {
        payload: Object,
        holderId: {},   //fq_id, react_id, var_id
        holderParentId: {}, //only for unit react_id, var_id
        holderParentType: {}, //  react, var
    },
    data() {
        return {
            types: [
                {id: 'text', name: 'Text'},
                {id: 'picture', name: 'Picture'},
                {id: 'container', name: 'Container'},
                {id: 'date', name: 'Date'},
                {id: 'datetime', name: 'DateTime'},
                {id: 'textarea', name: 'Textarea'},
            ]
        }
    },
    computed: {},
    methods: {
        changeType(key, type) {
            if (type === 'picture') {
                this.payload[key].value = pictureEmptyValue()
            } else if (type === 'container') {
                this.payload[key].value = {}
            } else {
                this.payload[key].value = ''
            }

        },
        async add() {
            let response = await this.$dialogs.prompt({message: 'Item name'})
            if (response.trigger !== 'ok') return
            this.$set(this.payload, response.value, {type: 'text', value: ''})
        },
        async editKey(key) {
            let response = await this.$dialogs.prompt({message: 'Item name', value: key})
            if (response.trigger !== 'ok') return
            this.$set(this.payload, response.value, this.payload[key])
            this.$delete(this.payload, key);
        },
        async deleteKey(key) {
            let response = await this.$dialogs.confirmDelete({
                message: `Are you sure want to delete  "${key}"?`
            })
            if (response.trigger !== 'ok') return
            this.$delete(this.payload, key);
        }
    }
}
</script>

<style scoped lang="scss">
@import "src/assets/scss/vue-component";

.unit-payload {
    margin-bottom: 0;

    .card-body {
        padding: .75rem;
    }
}

.payload-items {
    list-style: none;
    padding: 0;
    margin: 0;
}

.payload-item {
    display: grid;
    grid-gap: 1rem;
    align-items: start;
    grid-template-columns: 280px 110px 1fr;
    margin-bottom: 1rem;

    &:last-child {
        //margin-bottom: 0;
    }

    &__key {
        display: flex;
        align-items: center;
        justify-content: flex-start;
    }
}
</style>
